"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _bulk = _interopRequireDefault(require("./feedback/bulk.js"));

var _comments = _interopRequireDefault(require("./feedback/comments.js"));

var _manualScores = _interopRequireDefault(require("./feedback/manual-scores.js"));

var _rubrics = _interopRequireDefault(require("./feedback/rubrics.js"));

var _visibility = _interopRequireDefault(require("./feedback/visibility.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var sendScoreAndComments = function sendScoreAndComments(userKey, cardstackKey) {
  return Promise.all([_comments["default"].sendComments(userKey, cardstackKey), _manualScores["default"].sendManualScore(userKey, cardstackKey)]);
};

var markAllFeedbackAsRead = function markAllFeedbackAsRead(manualScoreKeys, commentKeys) {
  var markReadPromises = [];

  if (manualScoreKeys.length) {
    markReadPromises.push(_manualScores["default"].markAllManualScoresAsRead(manualScoreKeys));
  }

  if (commentKeys.length) {
    markReadPromises.push(_comments["default"].markAllCommentsAsRead(commentKeys));
  }

  return Promise.all(markReadPromises);
};

var _default = Object.assign({
  sendScoreAndComments: sendScoreAndComments,
  markAllFeedbackAsRead: markAllFeedbackAsRead
}, _manualScores["default"], _comments["default"], _rubrics["default"], _bulk["default"], _visibility["default"]);

exports["default"] = _default;